import ReactDOM from "react-dom";

export default function MyModalCDI(props) {
  return ReactDOM.createPortal(
    props.children,
    document.getElementById("modal")
  );
}
